export const transformCartData = (cartItems: any) => {
  if (!cartItems) return {};
  const {
    name,
    variant,
    price,
    totalPrice,
    count,
    lineItemId,
    lastPrice,
    productKey,
    _url,
    listPrice,
    activePriceType,
    priceLabel,
  } = cartItems;
  const color = variant?.attributes?.variantSelectorValue1;
  const size = `${variant?.attributes?.variantSelectorValue2} ${variant?.attributes?.variantSelectorValue3}`;
  const slug = variant?.attributes?.pdpSeo;
  const itemId = variant?.sku;
  const isOnStock = variant?.isOnStock;
  const restockableInDays = variant?.restockableInDays;
  const productImg = variant?.attributes?.mainImageURL ?? '';
  const itemNumber = variant?.attributes?.abwStyle ?? '';
  const warrenty = variant?.attributes?.warrantyEligible;
  const key = productKey ?? '';
  const availableQty = variant?.availableQuantity;
  const availableStatus = cartItems?.availabilityData?.message;
  const backOrderDate = cartItems?.availabilityData?.backOrderDate;
  const availableStatusColor = getStatusColor(cartItems?.availabilityData?.value);
  const availableStatusValue = cartItems?.availabilityData?.value;
  const backOrderValue = variant?.availabilityData?.backOrderValue;
  return {
    lineItemId,
    name,
    color,
    itemId,
    isOnStock,
    price,
    totalPrice,
    count,
    productImg,
    slug,
    originalPrice: lastPrice,
    itemNumber,
    warrenty,
    restockableInDays,
    size,
    key,
    availableQty,
    availableStatus,
    backOrderDate,
    availableStatusColor,
    availableStatusValue,
    backOrderValue,
    _url,
    listPrice,
    activePriceType,
    priceLabel,
  } as any;
};

export function sortNotesByTimestamp(notes: any) {
  // Check if the input is an array
  if (!Array.isArray(notes)) {
    return false;
  }

  // Check if any note object has an invalid or missing timestamp
  const hasInvalidTimestamp = notes.some((note) => {
    const timestamp = note.timeStamp;
    return typeof timestamp !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(timestamp);
  });

  if (hasInvalidTimestamp) {
    return false;
  }

  // If there's no data, return an empty array
  if (notes.length === 0) {
    return [];
  }

  // Sort the notes by timestamp
  return notes.sort((a, b) => {
    const timestampA: any = new Date(a.timeStamp);
    const timestampB: any = new Date(b.timeStamp);
    return timestampB - timestampA;
  });
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'outOfStock':
      return 'text-scarletRed';
    case 'backOrdered':
      return 'text-passionateBlue';
    default:
      return 'text-forestGreen';
  }
};
